import {MachinePolicyResource, WorkerMachineResource} from "../resources/index";
import BasicRepository from "./basicRepository";
import Client from "../client";
import {
    DeploymentTargetResource,
    ResourceCollection,
} from "client/resources";

class MachinePolicyRepository extends BasicRepository<any, any> {
    constructor(client: Client) {
        super("MachinePolicies", client);
    }
    getMachines(machinePolicy: MachinePolicyResource): Promise<ResourceCollection<DeploymentTargetResource>> {
        return this.client.get(machinePolicy.Links["Machines"]);
    }
    getWorkers(machinePolicy: MachinePolicyResource): Promise<ResourceCollection<WorkerMachineResource>> {
        return this.client.get(machinePolicy.Links["Workers"]);
    }
}

export default MachinePolicyRepository;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/repositories/machinePolicyRepository.ts